import { render, staticRenderFns } from "./Create-Department.vue?vue&type=template&id=5da3f94b&scoped=true&"
import script from "./Create-Department.vue?vue&type=script&lang=js&"
export * from "./Create-Department.vue?vue&type=script&lang=js&"
import style0 from "./Create-Department.vue?vue&type=style&index=0&id=5da3f94b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3f94b",
  null
  
)

export default component.exports